export const avatarGenerator = name => {
  if (name) {
    const fullname = name.split(' ');
    return fullname[0].charAt(0) + fullname.slice(-1)[0].charAt(0);
  }
  return null;
};
